import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const PdfEmbed = ({ embedURL }: any) => (
  <Container className="pdf-responsive" height="80vh" width="98vw">
    <iframe
      width="100%"
      height="100%"
      src={`https://reports-api.tatweertransit.com/pdfjs/web/viewer.html?file=${embedURL}`}
      frameBorder="0"
      title="Embedded pdf"
    />
  </Container>
);

PdfEmbed.propTypes = {
  embedURL: PropTypes.string.isRequired,
};

const Container = styled.div<any>`
  grid-area: ${(props) => props.gridArea};
  height: ${(props) => props.height ?? "500px"};
  width: ${(props) => props.width ?? "500px"};
  .pdf-responsive {
    overflow: hidden;
    padding-bottom: 56.25%;
    position: relative;
    height: 0;
  }

  .pdf-responsive iframe {
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    position: absolute;
  }
`;

export default PdfEmbed;

